import type { BaseRadii } from '../types/BaseTheme';

const radii: BaseRadii = {
  0: 0,
  circle: '50%',
};

export default radii;
